var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-top-5xl",
      staticStyle: {
        "--button-hover-background": "var(--theme-button-hover-background)",
        "--button-hover-border-color": "var(--theme-button-hover-border-color)",
      },
      attrs: { id: "icon-pack-icons" },
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            {
              staticClass:
                "row roomy align-between align-top margin-bottom-4xl",
            },
            [
              _c(
                "div",
                {
                  staticClass: "column display-flex tablet:flex-items-center",
                  staticStyle: { gap: "var(--spacing-xl)" },
                },
                [
                  _c(
                    "form",
                    {
                      staticClass: "icons-search form",
                      attrs: { method: "post", name: "header_search" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.search()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "with-icon-before",
                          staticStyle: {
                            "--input-padding":
                              "var(--spacing-sm) var(--spacing-xl) var(--spacing-xs) var(--spacing-xl)",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticStyle: { "line-height": "1", top: "13px" },
                            attrs: { icon: _vm.$v6.solid.faSearch },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "sr-only",
                              attrs: { for: "search_query" },
                            },
                            [
                              _vm._v(
                                "\n              Search " +
                                  _vm._s(_vm.iconPack().label) +
                                  " Icons\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "searchQuery",
                            staticClass: "rounded margin-bottom-0",
                            attrs: {
                              id: "search_query",
                              placeholder: `Search ${
                                _vm.iconPack().label
                              } icons...`,
                              name: "search_query",
                              type: "text",
                              value: "",
                            },
                            on: {
                              focus: function ($event) {
                                _vm.searchFieldFocus = true
                              },
                              blur: function ($event) {
                                _vm.searchFieldFocus = false
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "sr-only", attrs: { type: "submit" } },
                        [
                          _vm._v(
                            "\n            Search " +
                              _vm._s(_vm.iconPack().label) +
                              " Icons\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "button flat with-border margin-bottom-0 display-none tablet:display-inline-block",
                      staticStyle: {
                        "--border-color": "var(--fa-gravy)",
                        "--button-background": "transparent",
                        "--button-color": "var(--fa-navy)",
                      },
                      attrs: {
                        "aria-label": `Shuffle ${_vm.iconPack().label}'s Icons`,
                        "data-balloon-pos": "up",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.shuffleIcons()
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.$v6.solid.faShuffle, size: "lg" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column text-right" },
                [
                  _c(
                    "site-link",
                    {
                      staticClass: "button flat with-border margin-bottom-0",
                      staticStyle: {
                        "--border-color": "var(--fa-gravy)",
                        "--button-background": "transparent",
                        "--button-color": "var(--fa-navy)",
                      },
                      attrs: {
                        to: _vm.$search({ iconPacks: _vm.iconPack().name }),
                      },
                      nativeOn: {
                        click: function ($event) {
                          _vm.$posthog.capture(
                            "pack_landing:all_packs_link_click",
                            { pack: _vm.iconPack().name }
                          )
                        },
                      },
                    },
                    [
                      _vm._v("\n          View All\n          "),
                      _c(
                        "span",
                        { staticClass: "display-none tablet:display-inline" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.iconPack().label) +
                              " Icons\n            "
                          ),
                          _c("font-awesome-icon", {
                            staticClass: "margin-left-md",
                            attrs: {
                              icon: _vm.$v6.solid.faGrid2,
                              "fixed-width": "",
                              size: "lg",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.familyStyles, function (familyStyle, idx) {
            return _c("pack-icon-list", {
              key: idx,
              ref: `iconList${idx}`,
              refInFor: true,
              attrs: {
                index: _vm.algoliaIndex,
                "is-last": idx === _vm.familyStyles.length - 1,
                "is-pro-user": _vm.isProUser,
                "primary-color": _vm.iconPack().theme.primary,
                "search-field-focus": false,
                "selected-family": familyStyle.family,
                "selected-icon-id": `0`,
                "selected-style": familyStyle.style,
                version: _vm.version,
                "visual-tags": familyStyle.visualTags,
              },
              on: { toggleIcon: _vm.toggleIcon, closeIcon: _vm.closeIcon },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap-icon-detail", attrs: { id: "iconPreview" } },
        [
          _c(
            "transition",
            {
              attrs: {
                name: "toggle-icon-detail",
                appear: "",
                "enter-active-class":
                  "animate__animated animate__faster animate__fadeIn",
              },
              on: { "after-leave": _vm.ejectIconPreview },
            },
            [
              _c("modal-icon-detail", {
                ref: "iconModal",
                attrs: {
                  "default-styles": _vm.defaultStyles,
                  "icon-abstract": _vm.iconAbstract,
                  "icon-name": _vm.selectedIconId,
                  icon: _vm.icon,
                  index: _vm.algoliaIndex,
                  "is-duotone": _vm.isDuotoneIcon,
                  "is-pro-user": _vm.isProUser,
                  "is-showing": _vm.isShowingIconModal,
                  "selected-from-search": _vm.selectedIcon,
                  styling: _vm.styling,
                  viggo: _vm.viggo,
                },
                on: {
                  closeIcon: _vm.closeIcon,
                  nextIcon: _vm.nextIcon,
                  prevIcon: _vm.prevIcon,
                  resetStyles: _vm.resetStyles,
                  stylingChange: _vm.stylingChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }